import Axios from 'axios';
import { Toast } from 'vant';
import Utils from '../utils';

Axios.defaults.withCredentials = true;

export default {
    install(Vue) {
        /**
         * 定义请求
         */
        const DELAY_REQUEST_MESSAGE = 1000;

        /**
         * 请求拦截器
         */
        const preRequest = (config) => {
            // eslint-disable-next-line no-param-reassign
            config.$loadingTimer = setTimeout(() => {
                Toast.loading({ message: '努力加载中\n请稍候...', duration: 7000 });
            }, DELAY_REQUEST_MESSAGE);
            return config;
        };

        const errRequest = (err) => {
            clearTimeout(err.config.$loadingTimer);
            Toast.fail('请求失败\n请检查网络');
            return Promise.reject(err);
        };

        /**
         * 响应拦截器
         */
        const preResponse = (res) => {
            clearTimeout(res.config.$loadingTimer);

            if (typeof res.data.code === 'number' && res.data.message) {
                if (res.data.code === 1) {
                    if (res.config.method === 'get') {
                        Toast(res.data.message);
                    } else {
                        Toast.success(res.data.message);
                    }
                } else if (res.data.code === 0) {
                    const { apiUrlRoot } = window.$MIDE_CONFIG;
                    const returnUrl = encodeURIComponent(window.location.href);
                    if (Utils.env.isWxBrowser()) {
                        window.location.href = `${apiUrlRoot}/api/login?returnUrl=${returnUrl}`;
                    } else if (Utils.env.isAlipayBrowser()) {
                        Utils.alipay.getAuthCode().then((authCode) => {
                            window.location.href = `${apiUrlRoot}/api/login?authCode=${authCode}&returnUrl=${returnUrl}`;
                        });
                    } else {
                        Toast.fail('请用微信或支付宝打开');
                    }
                } else {
                    Toast.fail(res.data.message);
                }
            }

            return res;
        };

        const errResponse = (err) => {
            clearTimeout(err.config.$loadingTimer);
            Toast.fail('请求处理失败\n请稍候再试');
            return Promise.reject(err);
        };

        Axios.interceptors.request.use(preRequest, errRequest);
        Axios.interceptors.response.use(preResponse, errResponse);

        Axios.$success = (res) => {
            if (res.data.code !== 1) {
                return Promise.reject(res);
            }
            return res;
        };

        Axios.$fail = (err) => Promise.reject(err);

        /* eslint-disable no-param-reassign */
        Vue.$http = Axios;
        Vue.prototype.$http = Axios;
        /* eslint-disable no-param-reassign */
    },
};
